var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
var __extends =
  (this && this.__extends) ||
  (function () {
    var extendStatics = function (d, b) {
      extendStatics =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (d, b) {
            d.__proto__ = b
          }) ||
        function (d, b) {
          for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]
        }
      return extendStatics(d, b)
    }
    return function (d, b) {
      extendStatics(d, b)
      function __() {
        this.constructor = d
      }
      d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __())
    }
  })()
import React from 'react'
import styled from 'styled-components'
import { ODModal, ODModalBody, ODModalFooter, ODModalHeader } from '..'
import { ODIcon, ODIcons } from '../../../icons'
import { ODButton, ODButtonTheme } from '../../misc'
var Message = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      [
        '\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #2f353a;\n',
      ],
      [
        '\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #2f353a;\n',
      ]
    ))
)
var ConfirmModal = /** @class */ (function (_super) {
  __extends(ConfirmModal, _super)
  function ConfirmModal(props) {
    var _this = _super.call(this, props) || this
    _this.state = {}
    return _this
  }
  ConfirmModal.prototype.onClickYes = function () {
    this.props.onConfirm(true)
  }
  ConfirmModal.prototype.onClickNo = function () {
    this.props.onConfirm(false)
  }
  ConfirmModal.prototype.render = function () {
    var _this = this
    var _a = this.props,
      title = _a.title,
      message = _a.message,
      yes = _a.yes,
      no = _a.no,
      size = _a.size,
      isOpen = _a.isOpen,
      _b = _a.bodyStyle,
      bodyStyle = _b === void 0 ? {} : _b
    return React.createElement(
      ODModal,
      {
        isOpen: isOpen,
        toggle: function () {
          return _this.onClickNo()
        },
        size: size,
      },
      React.createElement(
        'div',
        { style: { display: 'flex', flexDirection: 'column' } },
        React.createElement(
          ODModalHeader,
          {
            title: title,
            onClose: function () {
              return _this.onClickNo()
            },
            headerBottomPadding: 30,
          },
          React.createElement(ODIcon, { icon: ODIcons.MaterialError, style: { fontSize: 60 } })
        ),
        React.createElement(ODModalBody, { style: bodyStyle }, React.createElement(Message, null, message)),
        React.createElement(
          ODModalFooter,
          null,
          React.createElement(
            ODButton,
            {
              style: { width: '35%' },
              theme: ODButtonTheme.Cancel,
              onClick: function () {
                return _this.onClickNo()
              },
            },
            no
          ),
          React.createElement(
            ODButton,
            {
              style: { width: '65%' },
              theme: ODButtonTheme.Primary,
              onClick: function () {
                return _this.onClickYes()
              },
            },
            yes
          )
        )
      )
    )
  }
  return ConfirmModal
})(React.Component)
export { ConfirmModal }
var templateObject_1
//# sourceMappingURL=ConfirmModal.js.map
